import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { salesPhone, whatsappUrl, quotePath } from '../utils/contactLinks';
import './CtaPanel.css';

// Closing call-to-action: quote, call or WhatsApp in one click.
function CtaPanel({
  title = 'Ready to start your project?',
  text = 'Speak to our team for expert advice and sharp pricing on ceiling, drywall and insulation supplies.',
}) {
  return (
    <section className="cta-panel-wrap" data-track-location="cta_panel">
      <div className="container cta-panel-container">
        <div className="cta-panel">
          <div className="cta-panel-copy">
            <h2>{title}</h2>
            <p>{text}</p>
          </div>
          <div className="cta-panel-actions">
            <Link to={quotePath} className="btn btn-sky">
              Request a quote <Icon name="arrow" />
            </Link>
            <a
              href={salesPhone.href}
              className="btn btn-ghost"
            >
              <Icon name="phone" /> {salesPhone.number}
            </a>
            <a
              href={whatsappUrl}
              className="btn btn-ghost"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="whatsapp" /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaPanel;
